const type = 'CLOSE_RECHARGE';

const closeRecharge = () => ({
  type,
});

export { type };
export default closeRecharge;
